import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface SchoolClosedIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const SchoolClosedIcon = ({ className, ...props }: SchoolClosedIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#school-closed-clip)">
      <path
        d="M3.84414 6.81102L3.84414 4.95102L3.76933 5.01087L3.76694 5.01245C3.52542 5.17339 3.21579 5.11768 3.04923 4.8888C2.88805 4.66729 2.94087 4.36282 3.1617 4.17705L3.16997 4.17021L7.44242 1.08416C7.78518 0.836738 8.24194 0.834255 8.56968 1.07778L8.57838 1.08434L12.8483 4.16854L12.8541 4.17252C13.0851 4.33211 13.1365 4.64606 12.9811 4.87491L12.9763 4.88181L12.9713 4.8888C12.8103 5.11007 12.4963 5.1712 12.2718 5.02498L12.265 5.02049L12.2629 5.01901L12.26 5.01797L12.2559 5.01628L12.2517 5.0143C12.2378 5.00744 12.2262 4.99678 12.2182 4.98356L12.2161 4.97991L12.2155 4.97876L12.1584 4.93309L12.1584 6.81102H13.9051C14.4331 6.81102 14.8684 7.23556 14.8855 7.75945L14.8859 7.77537L14.886 7.79148L14.886 14.0788L14.888 14.0791C15.1373 14.1108 15.3266 14.3158 15.3344 14.5726L15.3346 14.5804V14.589C15.3346 14.8735 15.1123 15.0986 14.8289 15.1031L1.18234 15.1031C0.894809 15.1031 0.667969 14.8764 0.667969 14.589C0.667969 14.3272 0.856153 14.1158 1.10698 14.0801L1.1146 14.0791L1.11658 14.0788L1.11658 7.7915C1.11658 7.2637 1.54134 6.82865 2.06548 6.81153L2.08139 6.81115L2.09752 6.81102L3.84414 6.81102ZM8.81481 12.377H7.13395V14.0569H8.81481V12.377ZM3.84414 7.83931L2.16328 7.83931L2.16328 14.0569H3.84414L3.84414 7.83931ZM7.9832 1.93616L4.8729 4.18422C4.88128 6.33674 4.88189 7.42714 4.8747 7.45545L4.8729 14.0569H6.10517V12.1498C6.10517 11.6707 6.53011 11.3374 7.06974 11.3308L7.08612 11.3307H8.89853C9.42897 11.3307 9.87056 11.6635 9.87933 12.1354L9.87947 12.1498L9.87946 14.0569H11.1297L11.1297 4.22816L7.9832 1.93616ZM12.1584 7.8393V14.0569H13.8393V7.8393H12.1584ZM7.98335 4.99956C9.02456 4.99956 9.86154 5.8361 9.86154 6.87679C9.86154 7.90568 9.0185 8.75404 7.98335 8.75404C6.94214 8.75404 6.10517 7.91752 6.10517 6.87681C6.10517 5.8361 6.94214 4.99956 7.98335 4.99956ZM7.98335 6.00994C7.5172 6.00994 7.13395 6.39299 7.13395 6.85887C7.13395 7.32473 7.51722 7.70779 7.98336 7.70779C8.44951 7.70779 8.83276 7.32473 8.83276 6.85887C8.83276 6.393 8.44949 6.00994 7.98335 6.00994Z"
        fill="currentColor"
      />
      <rect
        fill="currentColor"
        height="2"
        rx="1"
        stroke="white"
        transform="rotate(45 0.667969 -0.0404808)"
        width="21.6667"
        x="0.667969"
        y="-0.0404808"
      />
    </g>
    <defs>
      <clipPath id="school-closed-clip">
        <rect
          fill="white"
          height="16"
          width="16"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SchoolClosedIcon;
